import { render, staticRenderFns } from "./DebugCollectionItem.vue?vue&type=template&id=2e886b02"
import script from "./DebugCollectionItem.vue?vue&type=script&lang=js"
export * from "./DebugCollectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports